const Loader = () => {
  return (
    <div className="flex justify-center items-center h-full">
      <div className="flex justify-center items-center w-[80px] h-[120px]">
        <div className="w-[12px] ml-2 bg-primary-500 rounded-md animate-loader1"></div>
        <div className="w-[12px] ml-2 bg-primary-500 rounded-md animate-loader2"></div>
        <div className="w-[12px] ml-2 bg-primary-500 rounded-md animate-loader3"></div>
        <div className="w-[12px] ml-2 bg-primary-500 rounded-md animate-loader4"></div>
        <div className="w-[12px] ml-2 bg-primary-500 rounded-md animate-loader5"></div>
      </div>
    </div>
  );
};

export default Loader;
